import React, { useState, useEffect } from 'react';
import { Table, Dropdown, Menu, Button, Space, Typography, Modal, message, Descriptions } from 'antd';
import { EyeOutlined, DeleteOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'; // Si tu utilises React Router
import './ViewAllProvider.css';

const { Title } = Typography;

const ViewAllProvider = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  // Fetch categories from backend
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await fetch('/backend/view_all_categories.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok) {
        setDataSource(data.categories.map((cat, index) => ({ key: index + 1, ...cat })));
      } else {
        message.error(data.error || `Erreur HTTP ${response.status}`);
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
      message.error('Erreur réseau lors de la récupération des catégories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle view
  const handleView = (record) => {
    setSelectedCategory(record);
    setIsViewModalVisible(true);
  };

  // Handle delete
  const handleDelete = (record) => {
    setCategoryToDelete(record);
    setIsDeleteModalVisible(true);
  };

  // Handle delete confirmation
  const handleDeleteConfirm = async () => {
    if (!categoryToDelete) return;
    try {
      const response = await fetch('/backend/delete_category.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id: categoryToDelete.id }),
      });
      const data = await response.json();
      if (response.ok) {
        message.success(data.message || 'Catégorie supprimée avec succès');
        setIsDeleteModalVisible(false);
        setCategoryToDelete(null);
        fetchCategories();
      } else {
        message.error(data.error || `Erreur HTTP ${response.status}`);
      }
    } catch (error) {
      console.error('Erreur réseau lors de la suppression:', error);
      message.error('Erreur réseau lors de la suppression');
    }
  };

  // Handle delete cancel
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setCategoryToDelete(null);
  };

  // Handle view modal close
  const handleViewModalClose = () => {
    setIsViewModalVisible(false);
    setSelectedCategory(null);
  };

  // Menu for dropdown actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="2" icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  // Define columns
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Total Services', dataIndex: 'total_services', key: 'total_services' },
    { 
      title: 'Action', 
      key: 'action', 
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <Button icon={<DownOutlined />} size="small">
              Actions
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <div className="view-all-provider-container">
      
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 5 }}
        className="view-all-provider-table"
        loading={loading}
        scroll={{ x: true }}
      />
      {/* View Modal */}
      <Modal
        title={`Détails de la catégorie - ${selectedCategory?.name}`}
        open={isViewModalVisible}
        onOk={handleViewModalClose}
        onCancel={handleViewModalClose}
        okText="Fermer"
        cancelButtonProps={{ style: { display: 'none' } }}
        width={600}
      >
        {selectedCategory && (
          <Descriptions bordered column={1}>
            <Descriptions.Item label="ID">{selectedCategory.id}</Descriptions.Item>
            <Descriptions.Item label="Name">{selectedCategory.name}</Descriptions.Item>
            <Descriptions.Item label="Total Services">{selectedCategory.total_services || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Created At">{selectedCategory.created_at}</Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirmer la suppression"
        open={isDeleteModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        okText="Supprimer"
        okType="danger"
        cancelText="Annuler"
      >
        <p>Voulez-vous vraiment supprimer la catégorie {categoryToDelete?.name} ?</p>
      </Modal>
    </div>
  );
};

export default ViewAllProvider;